var _style, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGameLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 803,
    height: 803,
    viewBox: "0 0 803 803",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes a0_t { 0% { transform: translate(401.2px,401px) rotate(0deg) translate(-401.2px,-401px); } 100% { transform: translate(401.2px,401px) rotate(360deg) translate(-401.2px,-401px); } }\n@keyframes a1_t { 0% { transform: translate(401.2px,401px) rotate(0deg) translate(-278.4px,-332.7px); } 100% { transform: translate(401.2px,401px) rotate(720deg) translate(-278.4px,-332.7px); } }\n@keyframes a2_t { 0% { transform: translate(186.6px,224.8px); } 23.809% { transform: translate(186.6px,214.2px); } 47.619% { transform: translate(186.6px,224.8px); } 71.428% { transform: translate(186.6px,214.2px); } 100% { transform: translate(186.6px,224.8px); } }\n@keyframes a3_t { 0% { transform: translate(312.3px,531.6px); animation-timing-function: cubic-bezier(.5,0,.5,1); } 23.809% { transform: translate(312.3px,556.6px); } 47.619% { transform: translate(312.3px,531.6px); } 71.428% { transform: translate(312.3px,546.6px); } 100% { transform: translate(312.3px,531.6px); } }\n")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(401.2,401) translate(-401.2,-401)",
    style: {
      animation: "2.1s linear infinite both a0_t"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(399.5,399.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.7 49.3c8.3 1.1 14.2 8.7 12.9 17c-15 91.5-61.2 175.1-131.1 236.5c-69.9 61.4-158.8 96.5-251.4 99.6c-8.4 .3-15.2-6.6-15.1-15c0-8.4 6.8-15.1 15.2-15.4c85.2-3.1 167-35.5 231.2-92c64.3-56.5 107-133.4 121-217.5c1.4-8.3 9-14.2 17.3-13.2Z",
    fill: "#944ef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.5 15.7c0-8.7 7-15.7 15.7-15.7c8.6 0 15.7 7 15.7 15.7c0 8.7-7.1 15.7-15.7 15.7c-8.7 0-15.7-7-15.7-15.7Z",
    fill: "#944ef5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.2 353.1c-8.4-1-14.3-8.6-12.9-16.9c14.9-91.5 61.2-175.1 131-236.5c69.9-61.4 158.8-96.5 251.5-99.6c8.4-0.3 15.1 6.5 15.1 14.9c0 8.4-6.9 15.2-15.3 15.5c-85.2 3.1-166.9 35.5-231.2 92c-64.3 56.5-106.9 133.3-121 217.5c-1.4 8.2-8.9 14.1-17.2 13.1Z",
    fill: "#944ef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4 386.8c0 8.6-7 15.7-15.7 15.7c-8.7 0-15.7-7.1-15.7-15.8c0-8.6 7-15.7 15.7-15.7c8.7 0 15.7 7.1 15.7 15.8Z",
    fill: "#944ef5"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(401.2,401) translate(-278.4,-332.7)",
    style: {
      animation: "2.1s linear infinite both a1_t"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.6 129.1c-6.4-5.4-7.2-14.9-1.6-21.1c51.3-56 120.4-93 195.8-104.3c75.4-11.4 152.3 3.5 217.9 42c7.2 4.2 9.1 13.6 4.6 20.6c-4.5 7-13.9 8.9-21.1 4.7c-59.3-34.4-128.8-47.7-196.9-37.4c-68.1 10.2-130.5 43.4-177.1 93.8c-5.7 6.1-15.2 7-21.6 1.7Z",
    fill: "#944ef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4 155.6c0 8.7-7.1 15.7-15.7 15.7c-8.7 0-15.7-7-15.7-15.7c0-8.7 7-15.7 15.7-15.7c8.6 0 15.7 7 15.7 15.7Z",
    fill: "#944ef5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.1,494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.1 42.2c6.4 5.3 7.3 14.9 1.6 21c-51.3 56.1-120.3 93-195.8 104.4c-75.4 11.3-152.3-3.6-217.8-42c-7.2-4.2-9.2-13.6-4.7-20.6c4.6-7 13.9-9 21.1-4.8c59.4 34.4 128.8 47.8 196.9 37.5c68.2-10.3 130.6-43.5 177.1-93.8c5.7-6.2 15.2-7.1 21.6-1.7Z",
    fill: "#944ef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.4 15.7c0-8.7 7-15.7 15.7-15.7c8.7 0 15.7 7 15.7 15.7c0 8.6-7 15.7-15.7 15.7c-8.7 0-15.7-7.1-15.7-15.7Z",
    fill: "#944ef5"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(402.6,371.5) translate(-216,-146.7)",
    style: {
      animation: "2.1s linear infinite both a2_t"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.3 57.6c0-31.8 25.8-57.6 57.6-57.6c31.8 0 57.6 25.8 57.6 57.6v79.3v73.8c0 25.2-20.5 45.6-45.7 45.6h-23.8c-25.2 0-45.7-20.4-45.7-45.6v-73.8v-79.3Z",
    stroke: "#944ef5",
    strokeWidth: 28.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.5 57.6c0-31.8 25.8-57.6 57.6-57.6c31.8 0 57.6 25.8 57.6 57.6v79.3v73.8c0 25.2-20.5 45.6-45.7 45.6h-23.8c-25.2 0-45.7-20.4-45.7-45.6v-73.8v-79.3Z",
    stroke: "#944ef5",
    strokeWidth: 28.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M348 222.7h62.8c11.7 0 21.2-9.5 21.2-21.2v-32.4c0-6.9-3.3-13.3-8.9-17.3l-75.1-53.5v124.4Z",
    fill: "#944ef5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84 222.7h-62.8c-11.7 0-21.2-9.5-21.2-21.2v-32.4c0-6.9 3.3-13.3 8.9-17.3l75.1-53.5v124.4Z",
    fill: "#944ef5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.9,
    height: 112.6,
    fill: "#944ef5",
    transform: "translate(836.8,-658.1) rotate(90) translate(726.8,625)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9,
    height: 112.6,
    fill: "#944ef5",
    transform: "translate(957,-778.3) rotate(90) translate(847,625)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M233.7 281.3c0 6.6 5.3 12 12 12h59.2c6.6 0 12-5.4 12-12v-21.6h-83.2v21.6Z",
    fill: "#944ef5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.3 281.3c0 6.6 5.4 12 12 12h59.2c6.6 0 12-5.4 12-12v-21.6h-83.2v21.6Z",
    fill: "#944ef5"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(402.2,573.9) translate(-89.9,-42.3)",
    style: {
      animation: "2.1s linear infinite both a3_t"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7 81.9c-2.1 3.5-7.2 3.5-9.3 0l-21.3-37c-11.6-20 2.9-44.9 25.9-44.9c23.1 0 37.5 24.9 26 44.9l-21.3 37Z",
    fill: "#944ef5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M154.4 81.9c-2 3.5-7.2 3.5-9.3 0l-21.3-37c-11.5-20 2.9-44.9 26-44.9c23.1 0 37.5 24.9 25.9 44.9l-21.3 37Z",
    fill: "#944ef5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameLoading);
export default __webpack_public_path__ + "static/media/game-loading.c544881eb170e73349e4c92d1706a96c.svg";
export { ForwardRef as ReactComponent };